<template>
  <!-- 우측 배너 -->
  <div
    v-if="rightBanner.length > 0"
    class="right-banner-all"
  >
    <div
      v-for="banner in rightBanner"
      :key="banner.id"
      class="right-banner-item"
    >
      <a @click="handleBannerClick(banner.contentId, banner.contentType)">
        <img
          :src="banner.filePath"
          alt="right-banner"
        >
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SNT } from '@/core/global/global-enums'

export default {
  data() {
    return {
      rightBanner: []
    }
  },
  computed: {
    ...mapGetters({
      medicalDept: 'infoData/getMedicalDept',
      region: 'infoData/getRegion',
      shaEnLicenseNum: 'infoData/getShaEnLicenseNum',
      banners: 'infoData/getBanners',
    })
  },
  mounted() {
    this.getRightBanners()
  },
  methods: {
    getRightBanners() {
      this.rightBanner = this.banners.filter(x => x.bannerLocation === 13)
      if (this.rightBanner.length >= 3) {
        const shuffled = [...this.rightBanner].sort(() => Math.random() - 0.5)
        this.rightBanner = shuffled.slice(0, 3)
      }
    },
    handleBannerClick(contentId, contentType) {
      switch (contentType) {
        case 1:
          this.handleDrugInfoClick(contentId)
          break
        case 2:
          this.handleMedicalTrendClick(contentId)
          break
        case 3:
          this.handleSurveyClick(contentId)
          break
        case 5:
          this.handleWebseminarClick(contentId)
          break
        case 6:
          this.handleNoticeClick(contentId)
          break
        case 7:
          this.handleEventClick(contentId)
          break
        default:
          break
      }
    },
    handleDrugInfoClick(contentId) {
      this.$emit('open-drug-info', contentId, SNT.A.Service_컨텐츠__약품정보, SNT.B.Position_닥터인포__메인____Body____홈__배너_이미지_2, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleMedicalTrendClick(contentId) {
      this.$emit('open-medical-trend', contentId, SNT.A.Service_컨텐츠__메디컬트렌드, SNT.B.Position_닥터인포__메인____Body____홈__배너_이미지_2, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleSurveyClick(contentId) {
      this.$emit('open-survey', contentId, SNT.A.Service_컨텐츠__설문조사, SNT.B.Position_닥터인포__메인____Body____홈__배너_이미지_2, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleWebseminarClick(contentId) {
      this.$emit('open-webseminar', contentId, 1, SNT.A.Service_컨텐츠__웹세미나, SNT.B.Position_닥터인포__메인____Body____홈__배너_이미지_2, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleNoticeClick(contentId) {
      this.$emit('open-notice', contentId, SNT.A.Service_컨텐츠__공지사항, SNT.B.Position_닥터인포__메인____Body____홈__배너_이미지_2, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleEventClick(contentId) {
      this.$emit('open-event', contentId, SNT.A.Service_컨텐츠__이벤트, SNT.B.Position_닥터인포__메인____Body____홈__배너_이미지_2, SNT.C.State_Action__클릭_컨텐츠)
    },
  }
}
</script>
